module.exports = __webpack_public_path__ + "img/组 3.f4a54d3a.webp";